import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { ContributorsListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ContributorsDataCollection from 'modules/project_management/components/tables/ContributorsDataCollection'
import ContributorsDataTable from 'modules/project_management/components/tables/ContributorsDataTable'
import { UpsellContributorsMessage } from 'modules/project_management/components/upsells/UpsellContributorsMessage'

const ContributorsListPage = () => {
  useEffect(() => {
    track(trackingEvents.projectManagement.contributors.visitContributorsListSection)
  }, [])

  const {
    company: { id: companyId },
  } = useCurrentSession()
  const {
    data: page,
    loading,
    error,
  } = useQuery(ContributorsListPageDocument, {
    variables: {
      companyId: companyId,
      featureIds: [Features.projects_contributors],
    },
  })

  const hasContributorsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_contributors
  )?.available

  const canSeeContributors =
    !!page?.projectManagement.projectsConnection.nodes[0]?._policies?.assignEditor.can

  const dataCollectionsEnabled =
    page?.features.featuresConnection.nodes.find(
      (node) => node.name === 'dev_projects_data_collections'
    )?.enabled ?? false

  return (
    <ResponsivePage.Body
      variant="wide"
      loading={loading}
      error={error}
      authorized={canSeeContributors}
    >
      {dataCollectionsEnabled ? (
        hasContributorsFeature ? (
          <ContributorsDataCollection />
        ) : (
          <Box alignItems="center" justifyContent="center" style={{ height: '50vh' }}>
            <UpsellContributorsMessage />
          </Box>
        )
      ) : (
        <ContributorsDataTable hasContributorsFeature={hasContributorsFeature} />
      )}
    </ResponsivePage.Body>
  )
}

export default ContributorsListPage
